// helper function for composition API components e.g. for using modalController
export const getRouterElement = () => {
    return document.querySelector("ion-router-outlet") ?? undefined
}